module.exports = __webpack_public_path__ + "static/media/54798940_587107505109203_4068101720356421632_o.d71ccb1b.jpg";